import { render, staticRenderFns } from "./ArtistInfo.vue?vue&type=template&id=2dba11be"
import script from "./ArtistInfo.vue?vue&type=script&lang=js"
export * from "./ArtistInfo.vue?vue&type=script&lang=js"
import style0 from "./ArtistInfo.vue?vue&type=style&index=0&id=2dba11be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports